export enum DataTestId {
  PasswordInput = 'password-input',
  PasswordFeedbackText = 'password-feedback-text',
  PasswordRequirement = 'password-requirement',
  PasswordRequirementsToggle = 'password-requirements-toggle',
  PasswordRequirementsNote = 'password-requirements-note'
}
